export class HistoricGame {
    constructor(mode, createdAt, gameID, players) {
        this.mode = mode;
        this.createdAt = createdAt;
        this.gameID = gameID;
        this.players = players
    }
}